module.exports = __webpack_public_path__ + "static/favicon-4e78ec7dc6be4da55d2fc578f11a8ef7.ico";